import { WebSiteSchema } from "../components/structuredData";
import { useSeoMeta } from "../hooks/useSeoMeta";
import { FeaturedArea, PopularAreas, RecentAreas, YourAreas } from "../components/home/homeSections";
import "../components/home/home.css";

const HomeScreen = () => {
    useSeoMeta({
      title: "ClimbingWeather.com - Rock Climbing Weather Forecasts",
      description: "Get accurate weather forecasts for rock climbing areas across the United States. Plan your climbing trips with detailed hourly and daily weather predictions.",
      canonicalPath: "/"
    });

    return (
        <div className="cw-page home">
          <WebSiteSchema />
          <div className="home__body">
            <header className="home__intro">
              <h1 className="home__title">Rock climbing weather</h1>
              <p className="home__lede">Hourly and 7-day forecasts for climbing areas across the US, rated for climbing conditions.</p>
            </header>
            <FeaturedArea />
            <div className="home__mine">
              <YourAreas />
              <RecentAreas />
            </div>
            <PopularAreas />
          </div>
        </div>
      );
};

export default HomeScreen;
